<template>
  <h3 class="text-3xl text-6xl@lg font-weight-bold">
    <slot />
  </h3>
</template>
